import { render, staticRenderFns } from "./FbParagraph.vue?vue&type=template&id=54d47c96&scoped=true"
import script from "./FbParagraph.vue?vue&type=script&lang=js"
export * from "./FbParagraph.vue?vue&type=script&lang=js"
import style0 from "./FbParagraph.vue?vue&type=style&index=0&id=54d47c96&prod&lang=css"
import style1 from "./FbParagraph.vue?vue&type=style&index=1&id=54d47c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d47c96",
  null
  
)

export default component.exports